import React, { FC } from 'react';

import AppLoader from 'Src/components/AppLoader';
import { useTerminalSettings } from 'Src/feature/terminal/useTerminalSettings';

const sectionId = 'ChecksDefaultView';

/**
  Route control component that's only use is to show a loader
  - based on "terminalSettings.defaultView", this component will handle
    - data loading
    - data set up
    - routing
    - redirecting
 */
const ChecksDefaultView: FC = () => {
  //
  useTerminalSettings.defaultView.navigate.to();

  return (
    <AppLoader />
  );
};

export { ChecksDefaultView, sectionId };
